import { render, staticRenderFns } from "./BatchSetPaTrend.vue?vue&type=template&id=4d8c9c6c&scoped=true"
import script from "./BatchSetPaTrend.vue?vue&type=script&lang=js"
export * from "./BatchSetPaTrend.vue?vue&type=script&lang=js"
import style0 from "./BatchSetPaTrend.vue?vue&type=style&index=0&id=4d8c9c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c9c6c",
  null
  
)

export default component.exports